export default __webpack_public_path__ + "static/media/soldier_01.f6497a1b.jpeg";